export default async function ({ route, store }) {
  if (route?.name && !route?.name.includes("catalog-")) {
    await store.dispatch("global/retrieveSeoTexts", route?.path);
  }
}
